export default {
    state: false,
    status: 'success',
    title: '',
    text: '',
    open(status, title, text) {
        Alpine.store('body').fixed = true;
        this.status = status;
        this.title = title;
        this.text = text;
        this.state = true;
    },
    close() {
        Alpine.store('body').fixed = false;
        this.state = false;
    }
}